import React, { useEffect, useState, useCallback } from 'react';
import styled from 'astroturf/react';
import routes from 'js/core_pre_webpack/routes';
import { Icon } from 'js/design_system/Icon';
import { Tooltip } from 'js/design_system/new_tooltip/Tooltip';
import { PopoverMode } from 'js/design_system/Popover';
import { useScreenSize } from 'js/utils/hooks';
import { ImpressionWatcher } from 'js/utils/impressions';
import { HAMBURGER_MENU_SIZE } from './FocusedNav';
import { IconAnchor, IconContainer, IconLabel } from './buttonStyles';
import _GreenDot from "ImpactNavButton-GreenDot.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ImpactNavButton.tsx?styleId=GreenDot";
import _RelativeIconContainer from "ImpactNavButton-RelativeIconContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ImpactNavButton.tsx?styleId=RelativeIconContainer";


const TOOLTIP_STORAGE_KEY = 'impact_button_tooltip_shown';
export const GREEN_DOT_STORAGE_KEY = 'impact_hub_v2_visited';
const GREEN_COLOR = '#05B01C';

const GreenDot = /*#__PURE__*/styled("div", null, {
  displayName: "GreenDot",
  styles: _GreenDot
});

const RelativeIconContainer = /*#__PURE__*/styled(IconContainer, null, {
  displayName: "RelativeIconContainer",
  styles: _RelativeIconContainer
});

const ImpactNavButton: React.FC = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [showGreenDot, setShowGreenDot] = useState(true);
  const { screenWidth } = useScreenSize();
  const isMobile = screenWidth < HAMBURGER_MENU_SIZE;

  useEffect(() => {
    const hasSeenTooltip = localStorage.getItem(TOOLTIP_STORAGE_KEY);
    if (!hasSeenTooltip) {
      setShowTooltip(true);
      localStorage.setItem(TOOLTIP_STORAGE_KEY, 'true');
    }

    const hasVisitedImpactHubV2 = localStorage.getItem(GREEN_DOT_STORAGE_KEY);
    if (hasVisitedImpactHubV2) {
      setShowGreenDot(false);
    }
  }, []);

  const handleDismiss = useCallback(() => {
    setShowTooltip(false);
  }, []);

  const buttonContent = (
    <ImpressionWatcher key="impact" source="impact_hub.nav">
      <IconAnchor
        href={routes.impact_home_url({ from_navbar: true, trigger: 'nav' })}
        onClick={showTooltip ? handleDismiss : undefined}
      >
        <RelativeIconContainer>
          <Icon name="whatshot" size={24} />
          {showGreenDot && <GreenDot />}
        </RelativeIconContainer>
        <IconLabel>Impact</IconLabel>
      </IconAnchor>
    </ImpressionWatcher>
  );

  if (!showTooltip) {
    return buttonContent;
  }

  return (
    <Tooltip
      open={true}
      mode={PopoverMode.Click}
      placement={isMobile ? 'top' : 'bottom'}
      offset={isMobile ? 0 : 16}
      tooltipColor={GREEN_COLOR}
      tooltipTextColor="#fff"
      render={() => 'New'}
    >
      {buttonContent}
    </Tooltip>
  );
};

export default ImpactNavButton;
